// extracted by mini-css-extract-plugin
export default {"form":"TranslateFeedbackReviewForm_form__DaJPZ","form-group":"TranslateFeedbackReviewForm_form-group__UkbyM"};